import { render, staticRenderFns } from "./SettlementAccounts.vue?vue&type=template&id=2d0abd79&scoped=true&"
import script from "./SettlementAccounts.vue?vue&type=script&lang=js&"
export * from "./SettlementAccounts.vue?vue&type=script&lang=js&"
import style0 from "./SettlementAccounts.vue?vue&type=style&index=0&id=2d0abd79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0abd79",
  null
  
)

export default component.exports